import * as React from 'react';
import { connect } from 'react-redux';
import { IListItem } from '../../common/classes/list-item';
import { IAppState } from '../../common/classes/app';
interface ProviderProps {
    hideProviderImage: boolean;
    customDistanceErrorMessage: string;
    showDistanceFilter: boolean;
    enableAdvanceLocationLookup: boolean;
}

export type IProviderListItemProps = IListItem & ProviderProps

function openDialog(event) {
    let targetId = event.target.getAttribute('data-modal-name');
    let dialog = (window as any)[targetId];
    if (dialog) {
        dialog.show();
    }
}

const ProviderListItem: React.StatelessComponent<IProviderListItemProps> = props => {
    let isCHMGProvider;
    props.networks.some((net, idx) => (
        net === "CHMG Provider" ? isCHMGProvider = true : isCHMGProvider = false
    ))
    return (
        <li className={props.networkIcons && props.networkIcons.filter(item => item.showProviderOutline).length > 0 ? "adage-profile-item adage-search-item adage-search-item-highlight" : "adage-profile-item adage-search-item"}>
            <div className="adage-profile-item-inner">
                <div className="adage-profile-item-info">
                    <div className="adage-profile">
                        <div className={!props.hideProviderImage ? "adage-profile-details" : "adage-profile-details adage-profile-details-no-media"}>
                            <div className="adage-profile-name">
                                {!props.hideProviderImage ?
                                    <div className="adage-profile-media">
                                        <a href={props.ctaUrl} className="adage-profile-media-inner" aria-hidden="true" role="presentation">
                                            {
                                                props.picture
                                                    ?
                                                    <img src={props.picture} alt="" />
                                                    :
                                                    <svg className="svg-icon adage-profile-media-provider" aria-hidden="true" focusable="false">
                                                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-provider-placeholder" />
                                                    </svg>
                                            }
                                        </a>
                                    </div>
                                    : null
                                }

                                <div className="adage-profile-name-content">
                                    <h4 className="adage-profile-name-heading" data-provider={isCHMGProvider ? "chmg" : null} >
                                        {
                                            props.dontLinkToDetailPage ? <span>{props.name}</span> : <a href={props.ctaUrl}>{props.name}</a>
                                        }

                                        &nbsp;

                                        {
                                            isCHMGProvider ? <img className="icon-chmg" src="/Static/img/crozer-flag.svg" alt="" /> : null
                                        }
                                    </h4>

                                    {
                                        props.specialties ? <p className="adage-profile-name-subheading">{props.specialties.join(', ')}</p> : null
                                    }
                                </div>
                            </div>

                            <div className="adage-profile-content">
                                <ul className="adage-profile-icons-list">
                                    {props.networkIcons && props.networkIcons[0] ?
                                        props.networkIcons.map((icon, idx) => {
                                            return (
                                                <li key={idx}>
                                                    {icon.description ?
                                                        <button data-modal-name={icon.networkName.replace(/\s+/g, "") + "Modal"} onClick={openDialog} className="btn-text">
                                                            <svg className="svg-icon" aria-hidden="true" focusable="false" role="presentation">
                                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#icon-${icon.selectedIcon}`}></use>
                                                            </svg>
                                                            {icon.networkName}
                                                        </button>
                                                    :
                                                        <p>
                                                            <svg className="svg-icon" aria-hidden="true" focusable="false" role="presentation">
                                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#icon-${icon.selectedIcon}`}></use>
                                                            </svg>
                                                            {icon.networkName}
                                                        </p>
                                                    }
                                                </li>
                                            )
                                        }) : null
                                    }

                                    {props.patientAcceptances != null && props.patientAcceptances.length > 0 && props.patientAcceptances[0] != null ?
                                        <li className={props.isAcceptingNewPatient ? "" : "disabled"}>
                                            <svg className="svg-icon" aria-hidden="true" focusable="false" role="presentation">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-patients"></use>
                                            </svg>
                                            {props.patientAcceptances.length > 0 ? props.patientAcceptances[0] : "Does not Schedule Appointments"}
                                        </li>
                                        : null}

                                    {props.locations && props.locations.length > 0 ?
                                        <li>
                                            <svg className="svg-icon" aria-hidden="true" focusable="false" role="presentation">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location"></use>
                                            </svg>
                                            {props.locations.join(', ')}
                                        </li> : null
                                    }

                                    {props.minimumDistanceToLocation && props.showDistanceFilter && props.enableAdvanceLocationLookup ?
                                        <li>
                                            {props.minimumDistanceToLocation === 999999 ? props.customDistanceErrorMessage : "Distance: " + props.minimumDistanceToLocation + " miles"}
                                        </li> : null
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="adage-profile-item-aside">
                    {
                        /* If the form has the CTA Text and appointment URL, show Request and Appointment. Otherwise, if has a phone number, show "Contact Office". If nothing, empty text */
                        ((props.ctaText && props.requestAppointmentUrl) || props.phoneNumber) ?
                            <div className="adage-profile-content">
                                <h5 className="adage-profile-content-heading">{(props.ctaText && props.requestAppointmentUrl) ? "Request an Appointment" : "Contact Office"}</h5>

                                <div className="adage-profile-content-btns">
                                    <a className="btn adage-profile-content-phone" href={"tel:" + props.phoneNumber}>{props.phoneNumber}</a>

                                    {
                                        props.ctaText && props.requestAppointmentUrl ? <a className="btn btn-primary" href={props.requestAppointmentUrl}>{props.ctaText}</a> : null
                                    }
                                </div>
                            </div>
                            : null
                    }
                </div>
            </div>
        </li >
    )
}

function mapStateToProps(state: IAppState): ProviderProps {
    return {
        hideProviderImage: state.listingState.hideProviderImages,
        customDistanceErrorMessage: state.listingState.customDistanceErrorMessage,
        showDistanceFilter: state.listingState.showDistanceFilter,
        enableAdvanceLocationLookup: state.listingState.enableAdvanceLocationLookup
    }
}

export default connect(mapStateToProps)(ProviderListItem);